import React from 'react';
import compose from 'lodash/flow';
import { reactLinkModule } from '@xingternal/react-link-module';
import { splitkitHubModule } from '@xingternal/splitkit';
import { themingModule } from '@xingternal/theming-module';
import { withHub } from './withHub';
const withStaticDataOnly = (staticData) => (WrappedComponent) => {
    const Wrapper = ({ ...props }) => {
        return React.createElement(WrappedComponent, { ...props, ...staticData, type: 'static' });
    };
    Wrapper.displayName = `withStaticData(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return Wrapper;
};
const withStaticDataAndHub = (data) => {
    return compose(withStaticDataOnly(data), withHub([reactLinkModule, themingModule, splitkitHubModule]));
};
// separate exports
export { withStaticDataOnly, withStaticDataAndHub };
// default includes hub
export default withStaticDataAndHub;
//# sourceMappingURL=withStaticData.js.map